// extracted by mini-css-extract-plugin
module.exports = {"eggShapedPicture":"EggShapedPicture_eggShapedPicture__JiNcP","picture":"EggShapedPicture_picture__IVrjd"};